import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import AuthReducer from "./Reducers/AuthReducer";
import CategoryReducer from "./Reducers/CategoryReducer";
import ProductReducer from "./Reducers/ProductReducer";
import UserReducer from "./Reducers/UserReducer";
import SalesReducer from "./Reducers/SalesReducer";
import CustomersReducer from "./Reducers/CustomerReducer";
import DashboardReducer from "./Reducers/DashboardReducer";
import CurrencyReducer from "./Reducers/CurrencyReducer";
import VendorReducer from "./Reducers/VendorReducer";
import PurchaseReducer from "./Reducers/PurchaseReducer";
import CompanyReducer from "./Reducers/CompanyReducer";
import VatReducer, { SetupReducer } from "./Reducers/SetupReducer";
import PaymentMethodReducer from "./Reducers/PaymentMethodReducer";
import CashReceipeReducer from "./Reducers/CashReceiptReducer";
import PaymentReceiptReducer from "./Reducers/PaymentReceiptReducer";
import CashPaymentReducer from "./Reducers/CashPaymentReducer";
import ApVendorPaymentReducer from "./Reducers/ApVendorPaymentReducer";
import ExpenseReducer from "./Reducers/ExpenseReducer";
import vendorCustomerStatementReducer from "./Reducers/VendorCustomerStatementReducer";
import TenantReducer from "./Reducers/TenantReducer";
const rootReducers = combineReducers({
  AuthReducer,
  CategoryReducer,
  ProductReducer,
  UserReducer,
  SalesReducer,
  CustomersReducer,
  DashboardReducer,
  CurrencyReducer,
  VendorReducer,
  PurchaseReducer,
  CompanyReducer,
  VatReducer,
  PaymentMethodReducer,
  SetupReducer,
  cashReceipts: CashReceipeReducer,
  paymentReceipt: PaymentReceiptReducer,
  cashPaymentReceipts: CashPaymentReducer,
  vendorPayment: ApVendorPaymentReducer,
  expenseReducer: ExpenseReducer,
  vendorCustomerReducer: vendorCustomerStatementReducer,
  TenantReducer,
});

const middlewares = [thunk];

const Store = createStore(
  rootReducers,
  composeWithDevTools(applyMiddleware(...middlewares))
);
export default Store;
